module.exports = __webpack_public_path__ + "static/media/parents.2d774a76.png";